<template>
    <div class="mt-5">
        <div class="row justify-content-center">
            <div class="col-md-7">
                <div class="card shadow-sm border-0">
                    <div class="card-body text-center">

                        <h3 class="card-title mb-3">
                            <font-awesome-icon :icon="['fas', 'redo']" class="me-2 text-primary" />
                            Renovar Suscripción
                        </h3>

                        <p class="text-muted">
                            <font-awesome-icon :icon="['fas', 'calendar-plus']" class="me-1" />
                            <strong>Extensión:</strong> 1 mes adicional a tu suscripción actual.
                            <br />
                            <font-awesome-icon :icon="['fas', 'sync']" class="me-1" />
                            <strong>Renovación:</strong> manual, sin cobros automáticos.
                        </p>

                        <h4 class="mb-3 text-primary">
                            <font-awesome-icon :icon="['fas', 'dollar-sign']" class="me-1" />
                            15.000 ARS
                        </h4>

                        <p class="text-muted small mb-4">
                            Al pagar, se agregará un mes más de acceso completo al sistema desde tu fecha de vencimiento
                            actual.
                        </p>

                        <ul class="list-group text-start mb-4">
                            <li class="list-group-item border-0">
                                <font-awesome-icon :icon="['fas', 'cannabis']" class="me-2 text-success" />
                                Trazabilidad completa desde semilla a producto final.
                            </li>
                            <li class="list-group-item border-0">
                                <font-awesome-icon :icon="['fas', 'tasks']" class="me-2 text-success" />
                                Gestión de tareas, lotes y personal operativo.
                            </li>
                            <li class="list-group-item border-0">
                                <font-awesome-icon :icon="['fas', 'chart-pie']" class="me-2 text-success" />
                                Métricas, gráficos y control de costos.
                            </li>
                            <li class="list-group-item border-0">
                                <font-awesome-icon :icon="['fas', 'file-contract']" class="me-2 text-success" />
                                Módulo de cumplimiento normativo.
                            </li>
                        </ul>


                        <div class="mb-4 p-3 bg-light rounded border">
                            <p class="mb-1">
                                <font-awesome-icon :icon="['fas', 'clock']" class="me-2 text-secondary" />
                                <strong>Vencimiento actual:</strong>
                                {{ suscripcion?.fecha_fin ? new Date(suscripcion.fecha_fin).toLocaleDateString('es-AR')
                                    : 'No disponible' }}
                            </p>
                            <p class="mb-0" v-if="diasRestantes !== null">
                                <font-awesome-icon :icon="['fas', 'hourglass-half']" class="me-2 text-secondary" />
                                <span v-if="vencida">Tu suscripción está <strong
                                        class="text-danger">vencida</strong>.</span>
                                <span v-else>Faltan <strong>{{ diasRestantes }}</strong> día(s) para el
                                    vencimiento.</span>
                            </p>
                        </div>


                        <button class="btn btn-outline-primary btn-lg w-100" @click="generarPago">
                            <font-awesome-icon :icon="['fas', 'wallet']" class="me-2" />
                            Renovar Ahora
                        </button>

                        <div class="mt-4">
                            <p class="text-muted small mb-1">
                                Se abrirá una ventana de <strong>MercadoPago</strong> para completar el pago de forma
                                segura.
                            </p>
                            <div id="wallet_container" class="text-center mt-2"></div>
                        </div>

                        <small class="text-muted d-block mt-3">
                            <font-awesome-icon :icon="['fas', 'lock']" class="me-1" />
                            Pago 100% seguro y encriptado con MercadoPago.
                        </small>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '@/axios'

import { differenceInDays, parseISO } from 'date-fns'

const user = JSON.parse(localStorage.getItem('user'))
const userId = user?.id

const suscripcion = ref(null)
const diasRestantes = ref(null)
const vencida = ref(false)

const producto = ref({
    title: 'Renovación Mensual',
    quantity: 1,
    price: 15000
})

const cargarSuscripcion = async () => {
    try {
        const { data } = await axios.get(`/api/suscripcion_club/`, { params: { user_id: userId } })

        suscripcion.value = data || null

        if (suscripcion.value?.fecha_fin) {
            const hoy = new Date()
            const vencimiento = parseISO(suscripcion.value.fecha_fin)
            diasRestantes.value = differenceInDays(vencimiento, hoy)
            vencida.value = diasRestantes.value < 0
        }
    } catch (e) {
        console.warn('No se pudo obtener la suscripción del club', e)
    }
}


const generarPago = async () => {
    try {
        const { data } = await axios.post('/api/mercadopago_create_preference', producto.value)

        if (!window.MercadoPago) {
            await new Promise((resolve, reject) => {
                const script = document.createElement('script')
                script.src = 'https://sdk.mercadopago.com/js/v2'
                script.onload = resolve
                script.onerror = reject
                document.head.appendChild(script)
            })
        }

        const mp = new window.MercadoPago(process.env.VUE_APP_MP_PUBLIC_KEY, { locale: 'es-AR' })

        mp.checkout({
            preference: { id: data.id },
            autoOpen: true // 👈 abre directo
        })

    } catch (error) {
        console.error('❌ Error al generar la preferencia de renovación:', error)
    }
}

onMounted(() => {
    cargarSuscripcion()

    if (!window.MercadoPago) {
        const script = document.createElement('script')
        script.src = 'https://sdk.mercadopago.com/js/v2'
        document.head.appendChild(script)
    }
})
</script>


<style scoped>
.card-title {
    font-weight: 600;
}

.bg-light {
    background-color: #f8f9fa !important;
}
</style>
